/**
 * Footer component
 * @author Carlos Romera <cromera@adasasistemas.com>
 */

// Library
import React from 'react';
import Link from 'next/link';
// Constant
import { CONSTANT } from '@const';

// CSS Style for this module
import styles from './footer.module.scss';

/**
 * Footer generic component
 * @returns a footer
 */
export const Footer = () => (
	<footer className={styles.footer}>
		<div className={styles.footerContent}>
			<Link href={CONSTANT.TERMS_AND_CONDITIONS_URL ?? ''} className={styles.footerLink}>
				Terms & Conditions
			</Link>
			<p>|</p>
			<Link href="/contact" className={styles.footerLink}>
				Contact Us
			</Link>
			<p>|</p>
			<Link href="/trades" className={styles.footerLink}>
				Trades Information
			</Link>
			<p>|</p>
			<Link href={CONSTANT.HELP_URL ?? ''} className={styles.footerLink}>
				Help
			</Link>
		</div>
	</footer>
);
